import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';

@Component({
  selector: 'app-confirm-ucpdom-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './confirm-ucpdom-modal.component.html',
  styleUrl: './confirm-ucpdom-modal.component.scss',
})
export class ConfirmUcpdomModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() ucpdomConfirmed = new EventEmitter<{
    ucpdomConfirmDate: Date | null;
  }>();

  ucpdomConfirmDate: Date | null = null;

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    this.ucpdomConfirmed.emit({
      ucpdomConfirmDate: this.ucpdomConfirmDate,
    });
  }
}
